import posthog from "posthog-js";

const KEY = process.env.POSTHOG_KEY ?? "";
const isDiscord = window.location.hostname.endsWith("discordsays.com") ||
  new URLSearchParams(window.location.search).get("frame_id") !== null;

export const platform = isDiscord ? "discord" : "web";

export function initAnalytics() {
  if (!KEY) return;
  posthog.init(KEY, {
    api_host: isDiscord ? "/ingest" : "https://us.i.posthog.com",
    person_profiles: "identified_only",
    autocapture: false,
    capture_pageview: false,
  });
}

export function identifyUser(id, props) {
  if (!KEY) return;
  posthog.identify(id, props);
}

export function track(event, props) {
  if (!KEY) return;
  posthog.capture(event, props);
}
